// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"781":"user-agreement","928":"privacy-policy"}[chunkId] + "." + {"781":"71c8ba2e","928":"316d87f3"}[chunkId] + ".css";
};